import { Drawer } from 'antd'
import { useFFEStore } from '../../../store/ffeStore'
import { LineItemDetailsPanel } from './LineItemDetailsPanel'

export const LineItemDetailsDrawer = () => {
  const itemId = useFFEStore((state) => state.lineItemDetailsDrawerId)
  const open = !!itemId

  const onClose = () => {
    useFFEStore.setState({ lineItemDetailsDrawerId: undefined })
  }

  return (
    <Drawer
      closable={false}
      placement="right"
      width={600}
      open={open}
      onClose={onClose}
      styles={{
        body: { padding: 0 }
      }}
    >
      {open && <LineItemDetailsPanel />}
    </Drawer>
  )
}
